import React, { Fragment, useEffect, useState } from 'react';
import moment from 'moment';

import { requestTrend as requestTrendProduct } from 'api/sfms/dashboard/product/output';
import {
  requestTrend as requestTrendRawMaterial,
  requestTrendStock
} from 'api/sfms/dashboard/rawMaterial/price';
import CommonContent from 'components/common-sfims/Content';
import Chart from 'components/pages/sfms/dashboard/trend/Chart';
import Search from 'components/pages/sfms/dashboard/trend/search/Content';
import Tab from 'components/pages/sfms/dashboard/trend/Tab';
import { getLoginInform } from 'function/login';
import { getErrorMessage } from 'function/message';
import { useConfirmModalState } from 'global/confirmModalState';
import usePlantState from 'global/plantState';
import { RESPONSE_CODE } from 'types/const';
import isEmpty from 'utils/isEmpty';

/**
 * 대시보드 > 추이 대시보드
 */
const Content = () => {
  /* variable */
  const { fatoryCodeSeq } = getLoginInform();

  /* recoil */
  const { setConfirmModal } = useConfirmModalState();
  const {
    plant: { hasReads: hasReadPlants }
  } = usePlantState();

  /* state */
  // 추이 정보
  const [inform, setInform] = useState({});
  // 검색 비활성화 여부
  const [isDisableSearch, setIsDisableSearch] = useState(false);
  // 추이 조회 요청 데이터
  const [params, setParams] = useState({});
  // 구분 (0: 원료 가격 추이, 1: 제품 생산량 추이, 2: 원재료비 추이)
  const [type, setType] = useState(0);

  /* watch */
  useEffect(() => {
    if (!isEmpty(params)) {
      requestTrend();
    }
  }, [params]);
  useEffect(() => {
    const format = 'YYYYMM';
    const { buCode } =
      hasReadPlants.find(({ seq } = {}) => seq === fatoryCodeSeq) ?? {};
    const params = { buCode };

    // 구분 변경 시 기존 추이 조회 요청 데이터 초기화
    switch (type) {
      // 원료 가격 추이
      case 0:
        Object.assign(params, {
          startPriceYm: moment().subtract(1, 'years').format(format),
          endPriceYm: moment().format(format),
          factoryCodeSeq: fatoryCodeSeq
        });

        break;

      // 제품 생산량 추이
      case 1:
        Object.assign(params, {
          startProdYm: moment().subtract(1, 'years').format(format),
          endProdYm: moment().format(format),
          factoryCodeSeqList: []
        });

        break;

      // 원재료비 추이
      case 2:
        Object.assign(params, {
          startPriceYm: moment().subtract(1, 'years').format(format),
          endPriceYm: moment().format(format),
          factoryCodeSeqList: []
        });

        break;
    }

    setParams(params);
  }, [type]);

  /* method */
  // 추이 조회 요청
  const requestTrend = async () => {
    setInform({});
    setIsDisableSearch(true);

    try {
      const {
        data = {},
        code,
        message
      } = await [
        requestTrendRawMaterial,
        requestTrendProduct,
        requestTrendStock
      ][type](params);

      if (code !== RESPONSE_CODE.Success) {
        throw {
          code,
          error: message
        };
      }

      setInform(data);
    } catch (error) {
      setConfirmModal({
        isOpen: true,
        message: getErrorMessage(error?.code, error?.error)
      });
    } finally {
      setIsDisableSearch(false);
    }
  };

  /* view */
  return (
    <CommonContent>
      <Fragment key="body">
        <Tab type={type} setType={setType} />
        <Search
          disabled={isDisableSearch}
          type={type}
          value={params}
          onChange={setParams}
        />
        <Chart inform={inform} type={type} />
      </Fragment>
    </CommonContent>
  );
};

export default Content;
